import { createFileRoute } from '@tanstack/react-router';
import { Chat } from '@/features/chat/Chat';

export const Route = createFileRoute('/_app/chat/$chatId')({
  component: ChatPage,
});

function ChatPage() {
  const { chatId } = Route.useParams();
  return <Chat session={chatId} />;
}
